///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ISuiOperationService, SuiTypeAction } from '@siklu/sui-lib/infrastructure';
import { Observable } from 'rxjs';

export class SuiActionConfig extends SuiTypeAction {
    public callback: () => Observable<any>;

    constructor(btnText: string) {
        super();
        this.btnText = btnText;
        this.btnIcon = undefined;
        this.btnIconSize = undefined;

        this.reloadRequired = false;
        this.disableRefreshTimer = true;
        this.interruptIfNoIpConnectivity = true;
        this.requestManagementConfig = undefined;

        this.delayOfRefreshTimerRelease = undefined;
    }

    canBePerformed(operationService: ISuiOperationService, deviceAssignedName: string, currentBlockDataIndex?: string): boolean {
        return true;
    }

    action(operationService: ISuiOperationService, deviceAssignedName: string, currentBlockDataIndex?: string): Observable<any> {
        return this.callback();
    }
}
